<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Events</h3>
                <template slot="buttons">
                    <app-segment-control
                        v-if="!isMobileScreenSize()"
                        :value="state"
                        :options="[{ title: 'Active', value: 'active' }, { title: 'All', value: 'all' }]"
                        name="student-event-list"
                        size="small"
                        @input="stateChange"/>
                    <app-button size="small" @click="showAddEvent = true">Add Event</app-button>
                </template>

                <event-table
                    :items="events"
                    :columns="['attendance','title','time','date','location']"
                    :allow-sort="true"
                    :remote-sort="false"
                    :student="student">
                    <template slot="actions">
                        <el-table-column
                            prop="in_waitlist"
                            label="In Waitlist"
                            min-width="75px">
                            <template slot-scope="scope">
                                {{ scope.row.in_waitlist ? 'Yes' : 'No' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions" width="150px" align="right">
                            <template slot-scope="scope">
                                <div class="table-buttons">
                                    <app-tooltip
                                        effect="dark"
                                        content="Remove From Event"
                                        placement="top-end">
                                        <app-button
                                            type="danger"
                                            size="mini"
                                            icon="icon-delete"
                                            @click.stop="handleRemove(scope.$index, scope.row)">
                                            <span class="visuallyhidden">Remove Student From Course</span>
                                        </app-button>
                                    </app-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                </event-table>
            </panel>
        </row>

        <modal v-model="showAddEvent">
            <student-add-event :student="student"/>
        </modal>
    </dashboard>
</template>

<script>
import { get, isMobileScreenSize } from '@/utilities'

import StudentAddEvent from './StudentAddEvent'
import EventTable from '../Event/EventTable'

import Student from '@/store/models/Student'
import Event from '@/store/models/Event'

export default {
    name: 'page-students-detail-events',
    components: {
        EventTable,
        StudentAddEvent
    },
    props: ['uuid', 'student'],
    data() {
        return {
            showAddEvent: false,
            state: 'active'
        }
    },
    computed: {
        events() { 
            return Event.query()
                .with('attendance')
                .with('location')
                .with('attendance', (query) => {
                    query.where('student_id', this.student.id)
                })
                .with('attendance.coordinates')
                .whereIdIn(this.student.events.map(item => item.id))
                .get()
        }
    },
    methods: {
        navigateToClassDetail(course) {
            this.$router.push({
                name: 'classes.detail',
                params: { uuid: course.uuid }
            })
        },
        handleRemove(index, row) {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to remove this event?'
            })
                .then(() => {
                    return this.student.$detach(row.id, 'events', 'removeStudentFromEvent')
                })
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'The event has been removed from the student!',
                        type: 'success',
                        offset: 75,
                        duration: 2000
                    })
                })
        },
        stateChange(state) {
            this.state = state
            Student.$one({ uuid: this.uuid, state })
        },
        get,
        isMobileScreenSize
    }
}
</script>

<style lang="stylus"></style>
